import { duckFinds } from '../../../mocks/whatTheDuck';

const duckLocations = [
  { id: 1, name: "Sugar Hill Community Park", city: "Sugar Hill", lat: 34.1073, lng: -84.0341 },
  { id: 2, name: "Suwanee Town Center", city: "Suwanee", lat: 34.0512, lng: -84.0705 },
  { id: 3, name: "Buford Library", city: "Buford", lat: 34.1226, lng: -84.0049 },
  { id: 4, name: "Coolray Field", city: "Lawrenceville", lat: 33.9531, lng: -83.9876 },
  { id: 5, name: "Peachtree Ridge Park", city: "Suwanee", lat: 34.0321, lng: -84.0612 },
  { id: 6, name: "Duluth Town Green", city: "Duluth", lat: 34.0026, lng: -84.1448 },
  { id: 7, name: "Gwinnett Place Mall", city: "Duluth", lat: 33.9657, lng: -84.1448 },
  { id: 8, name: "Tribble Mill Park", city: "Lawrenceville", lat: 33.9226, lng: -83.9712 },
  { id: 9, name: "Snellville Towne Center", city: "Snellville", lat: 33.8573, lng: -84.0018 },
];

export default function DuckMap() {
  return (
    <section className="py-20 bg-amber-50" id="duck-map">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block bg-yellow-200 text-yellow-800 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Live Sightings
          </span>
          <h2
            className="text-4xl font-extrabold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Track the Ducks 🦆
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            See where ducks have been spotted across Sugar Hill, Gwinnett County, and surrounding communities. Every pin is a moment of joy left by one of our moms!
          </p>
        </div>

        {/* Report Button */}
        <div className="flex justify-center mb-8">
          <a
            href="#submit"
            className="inline-flex items-center gap-2.5 bg-pink-500 hover:bg-pink-600 text-white font-bold text-sm px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md hover:-translate-y-0.5"
          >
            <i className="ri-map-pin-add-line text-base"></i>
            Report a Duck Sighting
          </a>
        </div>

        {/* Map + Sidebar Layout */}
        <div className="flex flex-col lg:flex-row gap-6 items-start">
          {/* Map Embed */}
          <div className="flex-1 w-full rounded-2xl overflow-hidden border-4 border-yellow-200 bg-white" style={{ minHeight: '480px' }}>
            <iframe
              title="Duck Sightings Map"
              src="https://www.google.com/maps/d/embed?mid=1cNzwFGrWr1vPnyTmdDeuzgDYL7OiHrE&ehbc=2E312F"
              width="100%"
              height="480"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          {/* Sidebar: Sighting List */}
          <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-3">
            <div className="bg-white rounded-2xl border border-yellow-100 p-4">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-xl">📍</span>
                <h3 className="font-bold text-gray-800 text-sm uppercase tracking-wide">Recent Sightings</h3>
              </div>
              <div className="flex flex-col gap-2.5 max-h-96 overflow-y-auto pr-1" style={{ scrollbarWidth: 'thin' }}>
                {duckFinds.map((duck, i) => (
                  <a
                    key={duck.id}
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(duck.location + ', Gwinnett County, GA')}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="flex items-start gap-3 p-2.5 rounded-xl hover:bg-yellow-50 transition-colors duration-150 cursor-pointer group"
                  >
                    <div className="w-8 h-8 flex items-center justify-center bg-yellow-100 rounded-full flex-shrink-0 mt-0.5 group-hover:bg-yellow-200 transition-colors">
                      <span className="text-sm">🦆</span>
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs font-bold text-gray-800 truncate">{duck.location}</p>
                      <p className="text-xs text-gray-400 mt-0.5">{duck.name} · {duck.date}</p>
                    </div>
                    <div className="ml-auto flex-shrink-0 w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-external-link-line text-pink-500 text-xs"></i>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* Stats Card */}
            <div className="bg-gradient-to-br from-yellow-400 to-amber-400 rounded-2xl p-5 text-center">
              <p className="text-4xl font-extrabold text-white mb-1">{duckFinds.length}</p>
              <p className="text-yellow-900 font-semibold text-sm">Ducks Found So Far</p>
              <div className="mt-3 flex items-center justify-center gap-1.5 text-yellow-900 text-xs font-medium">
                <i className="ri-map-pin-line"></i>
                <span>Across Gwinnett County &amp; beyond</span>
              </div>
            </div>

            {/* CTA Mini */}
            <div className="bg-pink-50 border border-pink-100 rounded-2xl p-4 text-center">
              <p className="text-xs text-gray-600 leading-relaxed mb-3">
                Found a duck? Add your pin to the map and share the joy!
              </p>
              <a
                href="#submit"
                className="inline-flex items-center gap-1.5 text-pink-600 font-bold text-xs hover:text-pink-700 cursor-pointer transition-colors whitespace-nowrap"
              >
                <i className="ri-quill-pen-line"></i>
                Submit Your Find ↓
              </a>
            </div>
          </div>
        </div>

        {/* Areas Covered Tags */}
        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {['Sugar Hill', 'Suwanee', 'Buford', 'Lawrenceville', 'Duluth', 'Snellville', 'Lilburn', 'Loganville', 'Grayson', 'Dacula'].map((area) => (
            <span
              key={area}
              className="bg-white border border-yellow-200 text-yellow-800 text-xs font-semibold px-3 py-1.5 rounded-full"
            >
              📍 {area}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
